var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2775CA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12.5,
    stroke: "white",
    strokeWidth: 1.2,
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 9.5,
    stroke: "white",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 17.35C17.05 17.85 16.65 18.15 16 18.15C15.15 18.15 14.65 17.7 14.65 16.95C14.65 16.25 15.15 15.85 16.15 15.6L17.15 15.35V17.35ZM18.55 14.95C18.7 14.15 18.2 13.45 17.2 13.15V11.35H15.7V13.05C14.35 13.3 13.35 14.15 13.25 15.45H14.85C14.95 14.85 15.4 14.5 16.1 14.5C16.85 14.5 17.25 14.9 17.25 15.5V15.85L15.85 16.2C14.15 16.65 13.25 17.45 13.25 18.75C13.25 20.15 14.35 21.1 15.7 21.35V23.15H17.2V21.4C18.65 21.15 19.7 20.2 19.9 18.8H18.3C18.15 19.45 17.7 19.85 16.95 19.85C16.15 19.85 15.7 19.45 15.7 18.8C15.7 18.25 16.05 17.9 16.9 17.65L18.55 17.2V14.95Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdc);
export default __webpack_public_path__ + "static/media/usdc.38c84cbf7932611248e66593198390d5.svg";
export { ForwardRef as ReactComponent };